import { H_REFERENCIAL_WATERMASS } from 'account/constants/AccessRulesConstants'
import FixedSlideNav from 'components/navbar/FixedSlideNav'
import BoundaryError from 'log/components/BoundaryError'
import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { Outlet, useParams } from 'react-router-dom'
import { REFERENCIAL_TYPE_NAME } from 'referencial/constants/ReferencialConstants'
import i18n from 'simple-react-i18n'
import { componentHasHabilitations } from 'utils/HabilitationUtil'
import WatermassAction from '../actions/WatermassAction'

const WatermassRouterApp = () => {
    const dispatch = useDispatch()
    const { code } = useParams()

    const navLinks = useMemo(() => {
        return [{
            icons: 'dashboard',
            name: i18n.dashboard,
            href: `/referencial/${REFERENCIAL_TYPE_NAME.watermass}/${code}/dashboard`,
            habilitation: H_REFERENCIAL_WATERMASS,
        }, {
            icons: 'map',
            name: i18n.cartography,
            href: `/referencial/${REFERENCIAL_TYPE_NAME.watermass}/${code}/map`,
            habilitation: H_REFERENCIAL_WATERMASS,
        }, {
            icons: 'invert_colors',
            name: i18n.state,
            href: `/referencial/${REFERENCIAL_TYPE_NAME.watermass}/${code}/state`,
            habilitation: H_REFERENCIAL_WATERMASS,
        }].filter(l => componentHasHabilitations(l.habilitation))
    }, [code])

    useEffect(() => {
        dispatch(WatermassAction.fetchWatermasses())
        if (code !== 'new') {
            dispatch(WatermassAction.fetchWatermass(code))
        }
    }, [dispatch, code])

    return (
        <div className='row no-margin'>
            <FixedSlideNav links={navLinks} />
            <main>
                <div className='row no-margin padding-left-1'>
                    <div className='content-page no-padding fullscreen'>
                        <BoundaryError>
                            <Outlet />
                        </BoundaryError>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default WatermassRouterApp